import script from "./CreateDataCorrDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateDataCorrDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CreateDataCorrDialog.vue?vue&type=style&index=0&id=6d39604a&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d39604a"]])

export default __exports__